<template>
  <v-app
    style="width: 1024px"
  >
    <v-container
      v-if="loadingComplete"
      id="loaded"
    >
      <v-row>
        <v-container>
          <v-img
            contain
            :src="item._headerUrl"
            max-height="80px"
            max-width="400px"
            class="headerLogo"
          >
          </v-img>
        </v-container>
        <v-container
          class="headerReturnAddr"
        >
          <p class="my-0 headerAddrFont">
            {{ item._store.display_text }}
          </p>
          <p class="my-0 headerAddrFont">
            {{ item._store.street_number }}
          </p>
          <p class="my-n1 headerAddrFont">
            {{ item._store.city + ', ' + item._store.state }}
          </p>
        </v-container>
        <v-container
          class="headerDestAddr"
        >
          <span class="headerAddrFont">{{ item.pmt_name }}</span>
          <p class="my-n1 headerAddrFont">
            {{ item._address.addr1 }}
          </p>
          <p class="my-n1 headerAddrFont">
            {{ item._address.city + ', ' + item._address.state + ' ' + item._address.zip }}
          </p>
        </v-container>
        <v-container>
          <hr class="new4" />
        </v-container>
        <v-container
          class="headerInvoiceDetails"
        >
          <table>
            <thead>
              <tr>
                <th>
                  Payment Date
                </th>
                <th>
                  Payment #
                </th>
                <th>
                  Customer #
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  width="140px"
                  class="text-center"
                >
                  {{ formatDate(item.pmt_date) }}
                </td>
                <td
                  width="140px"
                  class="text-center"
                >
                  {{ item.pmt_id }}
                </td>
                <td
                  width="140px"
                  class="text-center"
                >
                  {{ item.pmt_custid }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-container>
        <v-container
          class="headerStatementSummary"
        >
          <h2>
            Payment Summary
          </h2>
          <table>
            <tbody>
              <tr>
                <td
                  colspan="2"
                  class="cellTopBorder"
                >
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td
                  width="160px"
                  class="text-left headerStatementSummaryText"
                >
                  Total
                </td>
                <td
                  width="160px"
                  class="text-right headerStatementSummaryText"
                >
                  ${{ item.pmt_total.toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td
                  class="text-left headerStatementSummaryText"
                >
                  Applied
                </td>
                <td
                  class="text-right headerStatementSummaryText"
                >
                  ${{ item.pmt_applied.toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td
                  class="text-left headerStatementSummaryText"
                >
                  Method
                </td>
                <td
                  class="text-right headerStatementSummaryText"
                >
                  {{ item.pt_name }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-container>
      </v-row>
      <v-container class="paymentDetails">
        <v-row
          class="ml-10"
        >
          <v-col cols="6">
            <h1 class="mb-3">
              Payment Details
            </h1>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td class="text-left line-item">
                    <span class="line-item-hdr">Invoice</span>
                  </td>
                  <td class="text-left line-item">
                    <span class="line-item-hdr">Amount</span>
                  </td>
                </tr>
                <tr
                  v-for="(detail, i) in item.details"
                  :key="'detail' + detail.invoice + '-' + i"
                >
                  <td class="tddetail"><span class="line-item">{{ detail.pd_invoice }}</span></td>
                  <td class="tddetail"><span class="line-item">${{ detail.pd_amount.toFixed(2) }}</span></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

      </v-container>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'

  export default {
    name: 'Invoice',

    components: {
    },
    mixins: [basicMixin],

    data: () => ({
      item: {},
      loadingComplete: false,
    }),
    computed: {
      ...mapGetters(['isLoggedIn']),
    },
    watch: {
    },
    methods: {
      ...mapActions(['login', 'getPayment']),
      // ...mapActions({
      //   getInvoice:
      // })
    },
    async mounted () {
      const queryToken = this.$route.query.token ? this.$route.query.token : false
      const queryAccountKey = this.$route.query.account ? this.$route.query.account : false
      const queryPaymentKey = this.$route.query.payment ? this.$route.query.payment : false
      console.log(`Token: ${queryToken}`)
      console.log(`Account: ${queryAccountKey}`)
      console.log(`Payment: ${queryPaymentKey}`)
      try {
        this.item = await this.getPayment({ authToken: queryToken, account_key: queryAccountKey, payment_key: queryPaymentKey })
        console.log(this.item)
        this.loadingComplete = true
      } catch (e) {
        console.log(e)
      }
    },
  }
</script>

<style scoped>
  .headerLogo{
    position: absolute;
    top: 28px;
    left: 650px;
  }
  .headerReturnAddr{
    position: absolute;
    top: 0px;
    font-size: 13px;
  }
  .headerAddrFont{
    font-size: 22px;
  }
  .headerDestAddr{
    position: absolute;
    top: 262px;
    font-size: 13px;
  }
  .headerPhoneNum{
    width: 100%;
    position: absolute;
    top: 960px;
    font-size: 15px;
  }
  .headerInvoiceDetails{
    position: absolute;
    top: 115px;
    left: 610px;
    font-size: 15px;
  }
  .headerStatementSummary{
    position: absolute;
    top: 210px;
    left: 658px;
  }
  .headerStatementSummaryText {
    font-size: 16px;
  }
  .paymentDetails{
    position: absolute;
    top: 410px;
  }
  .perf {
    width: 100%;
    position: absolute;
    top: 986px
  }
  .detachReturnAddr{
    width: 58%;
    position: absolute;
    top: 1150px;
    border-style: solid;
    border-color: black;
    border-width: 1px;
  }
  .detachDestAddr{
    width: 100%;
    position: absolute;
    top: 1400px;
    left: 120px;
  }
  .detachInvoiceCustNum{
    position: absolute;
    top: 1075px;
    left: 700px;
  }
  .detachAmountPaid{
    position: absolute;
    top: 1150px;
    left: 700px;
  }
  .detachSatisfactionSurvey{
    position: absolute;
    top: 1300px;
    left: 600px;
  }
  .detachSatisfactionSurveyFont{
    font-size: 15px;
  }
  .perf-note {
    font-size: 12px;
  }
  .tableBordered {
    border-width: 2px;
    border-style: solid;
    border-color: black;
  }
  .cellTopBorder {
    border-top: 1px solid black;
  }
  /* Thick red border */
  hr.new4 {
    position: absolute;
    width: 100%;
    top: 125px;
    border: 1px solid black;
  }
  .line-item {
    font-size: 18px;
    font-family: Roboto, sans-serif;
  }
  .line-item-hdr {
    font-size: 20px;
    font-weight: bold;
    font-family: Roboto, sans-serif;
  }

</style>
